import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteQuestionSequenceQuestionMutation, deleteQuestionSequenceQuestionMutationVariables } from '../generated/deleteQuestionSequenceQuestionMutation';
import { questionSequenceQuestionFieldsFragment } from '../models/QuestionSequenceQuestion';

/**
 * Get a callback to delete a QuestionSequenceQuestion in the store.
 */
export function useDeleteQuestionSequenceQuestionCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteQuestionSequenceQuestionMutation, deleteQuestionSequenceQuestionMutationVariables>(
        gql`
            mutation deleteQuestionSequenceQuestionMutation ($id: ID!) {
                deleteQuestionSequenceQuestion(id: $id) {
                    ...questionSequenceQuestionFields
                }
            }

            ${questionSequenceQuestionFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
